import React from 'react';

/**
 * PageContainer - omotač stranice (pun ekran, fiksna visina prema vidljivom
 * delu ekrana - vidi `.page-container` u App.css).
 *
 * `bare` se koristi kada je stranica prikazana UNUTAR druge stranice (npr.
 * tab „Grupe" unutar stranice „Organizacija"): tada `PageContainer` već
 * postoji na roditeljskoj stranici, pa se ovde ne renderuje drugi (ugnježdeni)
 * kontejner sa fiksnom visinom - samo sadržaj.
 */
const PageContainer = ({ children, bare = false }) => {
  if (bare) return <>{children}</>;

  return (
    <div className="page-container">
      {children}
    </div>
  );
};

export default PageContainer;
